export default __webpack_public_path__ + "static/media/career_oppo.f6c7acf3.jpg";